export enum Step {
  AGENTS = 'agents',
  CONFIGURATION = 'configuration',
  PROCESSING = 'processing',
}
